import React, { useState, useEffect, useCallback } from "react";
import {
  AiOutlineArrowRight,
  AiOutlineCamera,
  AiOutlineDelete,
} from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { server } from "../../server";
import styles from "../../styles/styles";
import { DataGrid } from "@mui/x-data-grid";
import { Modal, Button, Table } from "@mui/material";
import { Link } from "react-router-dom";
import { MdTrackChanges } from "react-icons/md";
import { RxCross1 } from "react-icons/rx";
import {
  deleteUserAddress,
  loadUser,
  updateUserAddress,
  updateUserInformation,
  getSavedCarts,
  deleteSavedCart,
} from "../../redux/actions/user";
import { clearCart, addTocart } from "../../redux/actions/cart";
import { Country, State } from "country-state-city";
import { toast } from "react-toastify";
import axios from "axios";
import { getAllOrdersOfUser } from "../../redux/actions/order";
import Loader from "../Layout/Loader";

const ProfileContent = ({ active }) => {
  const { user, error, successMessage } = useSelector((state) => state.user);
  const [name, setName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [phoneNumber, setPhoneNumber] = useState(user?.phoneNumber || "");
  const [gstNumber, setGstNumber] = useState(user?.gstNumber || "");
  const [billingAddress, setBillingAddress] = useState(user?.billingAddress || "");
  const [zipCode, setZipCode] = useState(user?.zipCode || "");
  const [password, setPassword] = useState("");
  const [avatar, setAvatar] = useState(null);
  const dispatch = useDispatch();
  const [currentBalance, setCurrentBalance] = useState(0);

  useEffect(() => {
    // Fetch and calculate the user's balance
    const fetchUserBalance = async () => {
      try {
        const { data } = await axios.get(`${server}/user/balance`, {
          withCredentials: true,
        });
        setCurrentBalance(data.balance);
      } catch (error) {
        console.error("Error fetching user balance:", error);
      }
    };

    fetchUserBalance();
  }, []);

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch({ type: "clearErrors" });
    }
    if (successMessage) {
      toast.success(successMessage);
      dispatch({ type: "clearMessages" });
    }
  }, [dispatch, error, successMessage]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      updateUserInformation(
        name,
        email,
        phoneNumber,
        gstNumber,
        billingAddress,
        zipCode,
        password
      )
    );
  };

  const handleImage = async (e) => {
    const reader = new FileReader();

    reader.onload = () => {
      if (reader.readyState === 2) {
        setAvatar(reader.result);
        axios
          .put(
            `${server}/user/update-avatar`,
            { avatar: reader.result },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            dispatch(loadUser());
            toast.success("Avatar updated successfully!");
          })
          .catch((error) => {
            toast.error(error.response.data.message);
          });
      }
    };

    if (e.target.files[0]) {
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  return (
    <div className="w-full p-4">
      {active === 1 && (
        <>
          <div className="flex flex-col items-center w-full">
            <div className="relative">
              <img
                src={user?.avatar?.url || "/default-avatar.png"}
                className="w-36 h-36 rounded-full object-cover border-4 border-green-500"
                alt="User Avatar"
              />
              <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center cursor-pointer absolute bottom-2 right-2">
                <input
                  type="file"
                  id="image"
                  className="hidden"
                  onChange={handleImage}
                />
                <label htmlFor="image" className="cursor-pointer">
                  <AiOutlineCamera size={16} />
                </label>
              </div>
            </div>
          </div>

          <div className="mt-6 px-4">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <label className="mb-1 font-medium">Full Name</label>
                  <input
                    type="text"
                    className={`${styles.input} w-full`}
                    required
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="mb-1 font-medium">Email Address</label>
                  <input
                    type="email"
                    className={`${styles.input} w-full`}
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <label className="mb-1 font-medium">Phone Number</label>
                  <input
                    type="tel"
                    className={`${styles.input} w-full`}
                    required
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="mb-1 font-medium">GST Number</label>
                  <input
                    type="text"
                    className={`${styles.input} w-full`}
                    required
                    value={gstNumber}
                    onChange={(e) => setGstNumber(e.target.value)}
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <label className="mb-1 font-medium">Billing Address</label>
                  <input
                    type="text"
                    className={`${styles.input} w-full`}
                    required
                    value={billingAddress}
                    onChange={(e) => setBillingAddress(e.target.value)}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="mb-1 font-medium">Zip Code</label>
                  <input
                    type="number"
                    className={`${styles.input} w-full`}
                    required
                    value={zipCode}
                    onChange={(e) => setZipCode(e.target.value)}
                  />
                </div>
              </div>

                {/* Display User Balance */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col ">
                <label className="mb-1 font-medium">Current Credit Balance</label>
                <div className="w-full p-2 bg-gray-100 rounded-md">
                  Rs {currentBalance.toFixed(2)}
                </div>
              </div>

                {/* Display User Balance */}
                <div className="flex flex-col">
                <label className="mb-1 font-medium">Aproved credit limit</label>
                <div className="w-full p-2 bg-gray-100 rounded-md">
                  Rs {user?.creditLimit?.toFixed(2) || '0.00'}
                </div>
              </div>
                </div>
              <div className="flex flex-col">
                <label className="mb-1 font-medium">Enter your password</label>
                <input
                  type="password"
                  className={`${styles.input} w-full`}
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>

              <div className="flex justify-center">
                <input
                  className="w-full md:w-64 h-10 bg-blue-600 text-white rounded-md cursor-pointer hover:bg-blue-700 transition-colors"
                  value="Update"
                  type="submit"
                />
              </div>
            </form>
          </div>
        </>
      )}

      {active === 2 && (
        <div className="mt-6">
          <AllOrders />
        </div>
      )}

      {active === 3 && (
        <div className="mt-6">
          <AllRefundOrders />
        </div>
      )}

      {active === 5 && (
        <div className="mt-6">
          <TrackOrder />
        </div>
      )}

      {active === 6 && (
        <div className="mt-6">
          <ChangePassword />
        </div>
      )}

      {active === 7 && (
        <div className="mt-6">
          <Address />
        </div>
      )}

      {active === 8 && (
        <div className="mt-6">
          <SavedCarts />
        </div>
      )}

      {active === 9 && (
        <div className="mt-6">
          <UserTransactions />
        </div>
      )}
    </div>
  );
};

const AllOrders = () => {
  const { user } = useSelector((state) => state.user);
  const { orders } = useSelector((state) => state.order);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      setIsLoading(true);
      try {
        if (user && user._id) {
          await dispatch(getAllOrdersOfUser(user._id));
        }
      } finally {
        setIsLoading(false);
      }
    };
    fetchOrders();
  }, [dispatch, user]);

  const handleDownloadInvoice = async (orderId) => {
    try {
      const response = await fetch(`${server}/invoice/download-invoice/${orderId}`, {
        method: "GET",
        credentials: "include",
        headers: {
          Accept: "application/pdf",
        },
      });

      if (response.ok) {
        const arrayBuffer = await response.arrayBuffer();
        const blob = new Blob([arrayBuffer], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        const contentDisposition = response.headers.get("Content-Disposition");
        let filename = `invoice_${orderId}.pdf`;
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+)"?/);
          if (match && match[1]) {
            filename = match[1];
          }
        }
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } else {
        const errorText = await response.text();
        console.error("Failed to download invoice:", errorText);
        toast.error("Failed to download invoice. Please try again.");
      }
    } catch (error) {
      console.error("Error fetching invoice:", error);
      toast.error("An error occurred while downloading the invoice.");
    }
  };

  const columns = [
    { field: "id", headerName: "Order ID", minWidth: 150, flex: 1 },
    {
      field: "status",
      headerName: "Status",
      minWidth: 130,
      flex: 1,
      cellClassName: (params) =>
         params.row.status === "Delivered"
          ? "text-green-600 font-semibold"
          : "text-red-600 font-semibold",
    },
    {
      field: "itemsQty",
      headerName: "Items Qty",
      type: "number",
      minWidth: 100,
      flex: 0.7,
    },
    {
      field: "total",
      headerName: "Total",
      type: "number",
      minWidth: 100,
      flex: 0.8,
      renderCell: (params) => <span>₹ {params.value}</span>,
    },
    {
      field: "view",
      headerName: "View Order",
      minWidth: 120,
      flex: 0.8,
      sortable: false,
      renderCell: (params) => (
        <Link to={`/user/order/${params.id}`}>
          <Button variant="outlined" color="primary" size="small">
            <AiOutlineArrowRight size={20} />
          </Button>
        </Link>
      ),
    },
  ];

  const rows = orders
    ? orders.map((item) => ({
        id: item._id,
        itemsQty: item.cart.length,
        total: item.shopTotalOrderPriceWithCommission.toFixed(2),
        status: item.status,
      }))
    : [];

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="datagrid-scroll-wrapper">
      <div className="table-inner-container" style={{ minWidth: "650px" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={10}
          disableSelectionOnClick
          autoHeight
          sx={{
            border: "none",
            "& .MuiDataGrid-virtualScroller": {
              overflow: "visible !important",
            },
          }}
        />
      </div>
    </div>
  );
};

const AllRefundOrders = () => {
  const { user } = useSelector((state) => state.user);
  const { orders } = useSelector((state) => state.order);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      setIsLoading(true);
      try {
        if (user && user._id) {
          await dispatch(getAllOrdersOfUser(user._id));
        }
      } finally {
        setIsLoading(false);
      }
    };
    fetchOrders();
  }, [dispatch, user]);

  const eligibleOrders = orders?.filter(
    (item) => item.status === "Processing refund"
  );

  const columns = [
    { field: "id", headerName: "Order ID", minWidth: 150, flex: 0.7 },
    {
      field: "status",
      headerName: "Status",
      minWidth: 130,
      flex: 0.7,
      cellClassName: (params) =>
         params.row.status === "Delivered"
          ? "text-green-500 font-semibold"
          : "text-green-300 font-semibold",
    },
    {
      field: "itemsQty",
      headerName: "Items Qty",
      type: "number",
      minWidth: 130,
      flex: 0.7,
    },
    {
      field: "total",
      headerName: "Total",
      type: "number",
      minWidth: 130,
      flex: 0.8,
      renderCell: (params) => <span>₹ {params.value}</span>,
    },
    {
      field: "action",
      headerName: "View Order",
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <Link to={`/user/order/${params.id}`}>
          <Button variant="outlined" color="primary" size="small">
            <AiOutlineArrowRight size={20} />
          </Button>
        </Link>
      ),
    },
  ];

  const rows = eligibleOrders
    ? eligibleOrders.map((item) => ({
        id: item._id,
        itemsQty: item.cart.length,
        total: `₹ ${item.shopTotalOrderPriceWithCommission.toFixed(2)}`,
        status: item.status,
      }))
    : [];

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="datagrid-scroll-wrapper">
      <div className="table-inner-container" style={{ minWidth: "650px" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={10}
          autoHeight
          disableSelectionOnClick
          sx={{
            border: "none",
            "& .MuiDataGrid-virtualScroller": {
              overflow: "visible !important",
            },
          }}
        />
      </div>
    </div>
  );
};

const TrackOrder = () => {
  const { user } = useSelector((state) => state.user);
  const { orders } = useSelector((state) => state.order);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      setIsLoading(true);
      try {
        if (user && user._id) {
          await dispatch(getAllOrdersOfUser(user._id));
        }
      } finally {
        setIsLoading(false);
      }
    };
    fetchOrders();
  }, [dispatch, user]);

  const columns = [
    { field: "id", headerName: "Order ID", minWidth: 150, flex: 1 },
    {
      field: "status",
      headerName: "Status",
      minWidth: 130,
      flex: 1,
      cellClassName: (params) =>
         params.row.status === "Delivered"
          ? "text-green-600 font-semibold"
          : "text-red-600 font-semibold",
    },
    {
      field: "itemsQty",
      headerName: "Items Qty",
      type: "number",
      minWidth: 100,
      flex: 0.7,
    },
    {
      field: "total",
      headerName: "Total",
      type: "number",
      minWidth: 100,
      flex: 0.8,
      renderCell: (params) => <span>₹ {params.value}</span>,
    },
    {
      field: "track",
      headerName: "Track Order",
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <Link to={`/user/track/order/${params.id}`}>
          <Button
            variant="contained"
            color="grey"
            size="small"
            startIcon={<MdTrackChanges size={20} />}
            className="flex items-center justify-center"
          >
            Track
          </Button>
        </Link>
      ),
    },
  ];

  const rows = orders
    ? orders.map((item) => ({
        id: item._id,
        itemsQty: item.cart.length,
        total: item.shopTotalOrderPriceWithCommission.toFixed(2),
        status: item.status,
      }))
    : [];

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="w-full overflow-x-auto px-4">
      <div style={{ minWidth: 650 }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={10}
          disableSelectionOnClick
          autoHeight
          className="data-grid"
        />
      </div>
    </div>
  );
};

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const passwordChangeHandler = async (e) => {
    e.preventDefault();

    await axios
      .put(
        `${server}/user/update-user-password`,
        { oldPassword, newPassword, confirmPassword },
        { withCredentials: true }
      )
      .then((res) => {
        toast.success(res.data.success);
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  return (
    <div className="w-full px-4 py-6 bg-white rounded-md shadow-md">
      <h1 className="text-2xl font-semibold text-center text-gray-800 mb-6">
        Change Password
      </h1>
      <form onSubmit={passwordChangeHandler} className="space-y-6">
        <div className="flex flex-col">
          <label className="mb-1 font-medium">Enter your old password</label>
          <input
            type="password"
            className={`${styles.input} w-full`}
            required
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
          />
        </div>
        <div className="flex flex-col">
          <label className="mb-1 font-medium">Enter your new password</label>
          <input
            type="password"
            className={`${styles.input} w-full`}
            required
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </div>
        <div className="flex flex-col">
          <label className="mb-1 font-medium">Confirm your new password</label>
          <input
            type="password"
            className={`${styles.input} w-full`}
            required
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>
        <div className="flex justify-center">
          <input
            className="w-full md:w-64 h-10 bg-blue-600 text-white rounded-md cursor-pointer hover:bg-blue-700 transition-colors"
            value="Update"
            type="submit"
          />
        </div>
      </form>
    </div>
  );
};

const Address = () => {
  const [open, setOpen] = useState(false);
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [addressType, setAddressType] = useState("");
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const addressTypeData = [
    { name: "Default" },
    { name: "Home" },
    { name: "Office" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!addressType || !country || !city) {
      toast.error("Please fill all the fields!");
      return;
    }

    dispatch(updateUserAddress(country, city, address1, address2, zipCode, addressType));
    setOpen(false);
    setCountry("");
    setCity("");
    setAddress1("");
    setAddress2("");
    setZipCode("");
    setAddressType("");
  };

  const handleDelete = (item) => {
    dispatch(deleteUserAddress(item._id));
  };

  return (
    <div className="w-full px-4 py-6 bg-white rounded-md shadow-md">
      {open && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="w-11/12 sm:w-1/2 lg:w-1/3 bg-white p-6 rounded-md relative">
            <RxCross1
              size={24}
              className="absolute top-4 right-4 cursor-pointer text-gray-600"
              onClick={() => setOpen(false)}
            />
            <h2 className="text-xl font-semibold text-center mb-4">Add New Address</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="flex flex-col">
                <label className="mb-1 font-medium">Country</label>
                <select
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                  className="border border-gray-300 rounded-md p-2"
                  required
                >
                  <option value="">Choose your country</option>
                  {Country.getAllCountries().map((item) => (
                    <option key={item.isoCode} value={item.isoCode}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex flex-col">
                <label className="mb-1 font-medium">State</label>
                <select
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  className="border border-gray-300 rounded-md p-2"
                  required
                >
                  <option value="">Choose your state</option>
                  {State.getStatesOfCountry(country).map((item) => (
                    <option key={item.isoCode} value={item.isoCode}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex flex-col">
                <label className="mb-1 font-medium">Address 1</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded-md p-2"
                  required
                  value={address1}
                  onChange={(e) => setAddress1(e.target.value)}
                />
              </div>

              <div className="flex flex-col">
                <label className="mb-1 font-medium">Address 2</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded-md p-2"
                  required
                  value={address2}
                  onChange={(e) => setAddress2(e.target.value)}
                />
              </div>

              <div className="flex flex-col">
                <label className="mb-1 font-medium">Zip Code</label>
                <input
                  type="number"
                  className="border border-gray-300 rounded-md p-2"
                  required
                  value={zipCode}
                  onChange={(e) => setZipCode(e.target.value)}
                />
              </div>

              <div className="flex flex-col">
                <label className="mb-1 font-medium">Address Type</label>
                <select
                  value={addressType}
                  onChange={(e) => setAddressType(e.target.value)}
                  className="border border-gray-300 rounded-md p-2"
                  required
                >
                  <option value="">Choose your Address Type</option>
                  {addressTypeData.map((item) => (
                    <option key={item.name} value={item.name}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex justify-center">
                <button
                  type="submit"
                  className="w-full md:w-48 h-10 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                >
                  Add Address
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="flex flex-col md:flex-row items-center justify-between mb-4">
        <h2 className="text-2xl font-semibold text-gray-800">My Addresses</h2>
        <button
          className={`${styles.button} rounded-md mt-4 md:mt-0`}
          onClick={() => setOpen(true)}
        >
          <span className="text-white">Add New</span>
        </button>
      </div>

      <div className="space-y-4">
        {user?.addresses.length > 0 ? (
          user.addresses.map((item, index) => (
            <div
              key={index}
              className="flex flex-col md:flex-row items-start md:items-center justify-between bg-gray-100 p-4 rounded-md shadow-sm"
            >
              <div className="flex flex-col md:flex-row items-start md:items-center">
                <h5 className="font-semibold mr-4">{item.addressType}</h5>
                <p className="text-sm text-gray-700">
                  {item.address1}, {item.address2}, {item.city}, {item.country}, {item.zipCode}
                </p>
              </div>
              <div className="mt-2 md:mt-0">
                <AiOutlineDelete
                  size={24}
                  className="text-red-500 cursor-pointer"
                  onClick={() => handleDelete(item)}
                />
              </div>
            </div>
          ))
        ) : (
          <h5 className="text-center text-gray-600">You do not have any saved address!</h5>
        )}
      </div>
    </div>
  );
};

const UserTransactions = () => {
  const { user } = useSelector((state) => state.user || {});
  const [transactions, setTransactions] = useState([]);
  const [balance, setBalance] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const fetchTransactions = async (userId, startDate, endDate) => {
    try {
      const response = await axios.get(`${server}/userTransaction/user/get-transactions/${userId}`, {
        params: { startDate, endDate },
        withCredentials: true,
      });

      return response.data.transactions.map((transaction) => ({
        id: transaction._id,
        date: new Date(transaction.transactionDate).toLocaleDateString(),
        orderId: transaction.orderId ? transaction.orderId : transaction._id,
        credit: transaction.type === "Credit" ? parseFloat(transaction.amount).toFixed(2) : "0.00",
        debit: transaction.type === "Debit" ? parseFloat(transaction.amount).toFixed(2) : "0.00",
        transactionType: transaction.transactionType,
        referenceNumber: transaction.referenceNumber,
      }));
    } catch (error) {
      console.error("Failed to fetch transactions", error);
      throw error;
    }
  };

  const fetchAndSetTransactions = useCallback(async () => {
    if (user?._id) {
      setIsLoading(true);
      try {
        const fetchedTransactions = await fetchTransactions(user._id, startDate, endDate);
        setTransactions(fetchedTransactions);

        const allTransactions = await fetchTransactions(user._id, "", "");
        const calculatedBalance = allTransactions.reduce((acc, transaction) => {
          return acc + (parseFloat(transaction.credit) - parseFloat(transaction.debit));
        }, 0);
        setBalance(calculatedBalance.toFixed(2));
      } catch (error) {
        console.error("Failed to fetch transactions", error);
      } finally {
        setIsLoading(false);
      }
    }
  }, [user, startDate, endDate]);

  useEffect(() => {
    fetchAndSetTransactions();
  }, [fetchAndSetTransactions]);

  const columns = [
    { field: "date", headerName: "Date", minWidth: 100, flex: 0.3 },
    {
      field: "transactionType",
      headerName: "Transaction Type",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "orderId",
      headerName: "Order ID / Transaction ID",
      minWidth: 200,
      renderCell: (params) =>
        params.row.transactionType === "Payment recorded" ? (
          params.row.referenceNumber || "N/A"
        ) : (
          <Link to={`/user/order/${params.row.orderId}`} className="text-blue-600 hover:underline">
            {params.row.orderId}
          </Link>
        ),
    },
    {
      field: "credit",
      headerName: "Credit",
      minWidth: 120,
      flex: 0.5,
      renderCell: (params) => `₹${params.value}`,
    },
    {
      field: "debit",
      headerName: "Debit",
      minWidth: 120,
      flex: 0.5,
      renderCell: (params) => `₹${params.value}`,
    },
  ];

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="w-full p-4 bg-white rounded-md shadow-md">
      <h1 className="text-2xl font-semibold text-center text-gray-800 mb-4">Account Transactions</h1>
      <div className="flex flex-col md:flex-row items-center justify-between mb-4 bg-gray-100 p-4 rounded-md">
        <div className="mb-4 md:mb-0">
          <h3 className="text-lg text-gray-700">Balance: ₹{balance}</h3>
        </div>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <div className="flex flex-col">
            <label className="text-sm text-gray-600">Start Date:</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="border border-gray-300 rounded-md p-2"
            />
          </div>
          <div className="flex flex-col">
            <label className="text-sm text-gray-600">End Date:</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="border border-gray-300 rounded-md p-2"
            />
          </div>
          <button
            onClick={fetchAndSetTransactions}
            className="mt-4 sm:mt-0 bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition-colors"
          >
            Filter
          </button>
        </div>
      </div>

      <div className="datagrid-scroll-wrapper">
        <div className="table-inner-container" style={{ minWidth: "650px" }}>
          <DataGrid
            rows={transactions}
            columns={columns}
            pageSize={9}
            autoHeight
            disableSelectionOnClick
            sx={{
              border: "none",
              "& .MuiDataGrid-virtualScroller": {
                overflow: "visible !important",
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

const SavedCarts = () => {
  const { user } = useSelector((state) => state.user);
  const savedCarts = useSelector((state) => state.user.savedCarts);
  const dispatch = useDispatch();
  const [selectedCart, setSelectedCart] = useState(null);
  const [popupOpen, setPopupOpen] = useState(false);
  const [productDetails, setProductDetails] = useState({});
  const [quantities, setQuantities] = useState({});
  const [totalPrices, setTotalPrices] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSavedCarts = async () => {
      setIsLoading(true);
      try {
        await dispatch(getSavedCarts());
      } finally {
        setIsLoading(false);
      }
    };
    fetchSavedCarts();
  }, [dispatch]);

  const fetchProductDetails = async (productId) => {
    try {
      const { data } = await axios.get(`${server}/product/product/${productId}`);
      return data.product;
    } catch (error) {
      console.error("Error fetching product details: ", error);
      return null;
    }
  };

  const handleCartClick = async (cart) => {
    const productDetailsMap = {};
    const quantitiesMap = {};
    const totalPricesMap = {};

    // NEW CODE: Use a single bulk API call to fetch all product details
const productIds = cart.items.map(item => item.productId).join(",");
try {
  const { data } = await axios.get(`${server}/product/bulk-products`, {
    params: { ids: productIds },
  });
  
  // Map products by their ID for quick lookup
  data.products.forEach((product) => {
    productDetailsMap[product._id] = product;
  });
  
  // For each cart item, get the product details and calculate prices
  cart.items.forEach((item) => {
    const product = productDetailsMap[item.productId];
    if (product) {
      quantitiesMap[item.productId] = item.quantity;
      const price = getPriceFromQuantity(
        product.quantitySlabsWithCommission,
        item.quantity
      );
      totalPricesMap[item.productId] = price * item.quantity;
    }
  });
} catch (error) {
  console.error("Error fetching bulk products:", error);
}


    setProductDetails(productDetailsMap);
    setQuantities(quantitiesMap);
    setTotalPrices(totalPricesMap);
    setSelectedCart(cart);
    setPopupOpen(true);
  };

  const getPriceFromQuantity = (slabs, quantity) => {
    const slab = slabs.find((s) => quantity >= s.min && quantity <= s.max);
    const maxSlab = slabs.reduce((max, slab) =>
      slab.max > max.max ? slab : max,
      slabs[0]
    );
    return slab ? slab.totalPriceWithCommission : maxSlab.totalPriceWithCommission;
  };

  const getPriceFromQuantityWithoutCommission = (slabs, quantity) => {
    const slab = slabs.find((s) => quantity >= s.min && quantity <= s.max);
    const maxSlab = slabs.reduce((max, slab) =>
      slab.max > max.max ? slab : max,
      slabs[0]
    );
    return slab ? slab.totalPrice : maxSlab.totalPrice;
  };

  const getDiscountPrice = (slabs, quantity) => {
    const slab = slabs.find((s) => quantity >= s.min && quantity <= s.max);
    const maxSlab = slabs.reduce((max, slab) =>
      slab.max > max.max ? slab : max,
      slabs[0]
    );
    return slab ? slab.discountPrice : maxSlab.discountPrice;
  };

  const handleQuantityChange = (productId, newQuantity) => {
    const validQuantity = isNaN(newQuantity) || newQuantity <= 0 ? 1 : newQuantity;
    setQuantities((prev) => ({ ...prev, [productId]: validQuantity }));
    const price = getPriceFromQuantity(
      productDetails[productId].quantitySlabsWithCommission,
      validQuantity
    );
    setTotalPrices((prev) => ({ ...prev, [productId]: price * validQuantity }));
  };

  const handleDeleteCart = (cartId) => {
    dispatch(deleteSavedCart(cartId)).then(() => {
      dispatch(getSavedCarts());
    });
    setSelectedCart(null);
    setPopupOpen(false);
  };

  const handleDeleteItem = (productId) => {
    const updatedItems = selectedCart.items.filter(
      (item) => item.productId !== productId
    );
    const updatedQuantities = { ...quantities };
    const updatedTotalPrices = { ...totalPrices };

    delete updatedQuantities[productId];
    delete updatedTotalPrices[productId];

    setSelectedCart({ ...selectedCart, items: updatedItems });
    setQuantities(updatedQuantities);
    setTotalPrices(updatedTotalPrices);

    toast.success("Item removed from cart!");
  };

  const handleProceedToOrder = () => {
    dispatch(clearCart());

    const updatedItems = [];

    selectedCart.items.forEach((item) => {
      const product = productDetails[item.productId];

      if (product) {
        const quantity = quantities[item.productId];
        const totalPriceWithCommission = getPriceFromQuantity(
          product.quantitySlabsWithCommission,
          quantity
        );
        const totalPriceWithoutCommission = getPriceFromQuantityWithoutCommission(
          product.quantitySlabs,
          quantity
        );
        const discountPrice = getDiscountPrice(
          product.quantitySlabs,
          quantity
        );

        const cartItem = {
          _id: item.productId,
          qty: quantity,
          totalPriceWithCommission,
          totalPriceWithoutCommission,
          discountPrice,
          hasVariants: product.hasVariants,
        variantKey: item.variantKey,
        variant: item.variant, 
          ...product,
        };

        updatedItems.push(cartItem);
      }
    });

    updatedItems.forEach((cartItem) => {
      dispatch(addTocart(cartItem));
    });

    setPopupOpen(false);
    toast.success("Cart updated with current items!");
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="w-full px-4 py-6 bg-white rounded-md shadow-md">
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">My Saved Carts</h2>
      
      {/* Scrollable container for the main table */}
      <div className="overflow-x-auto overflow-y-auto max-h-64 sm:max-h-80">
        <Table className="w-full table-auto text-xs sm:text-sm">
          <thead>
            <tr className="bg-gray-200">
              <th className="px-2 py-1">Bundle Name</th>
              <th className="px-2 py-1">Total Items</th>
              <th className="px-2 py-1">Created At</th>
              <th className="px-2 py-1">Delete</th>
            </tr>
          </thead>
          <tbody>
            {savedCarts && savedCarts.length > 0 ? (
              savedCarts.map((cart, index) => (
                <tr
                  key={index}
                  onClick={() => handleCartClick(cart)}
                  className="hover:bg-gray-100 cursor-pointer"
                >
                  <td className="border px-4 py-2">{cart.bundleName}</td>
                  <td className="border px-4 py-2 text-center">
                    {cart.items.length}
                  </td>
                  <td className="border px-4 py-2 text-center">
                    {new Date(cart.createdAt).toLocaleDateString()}
                  </td>
                  <td className="border px-4 py-2 text-center">
                    <AiOutlineDelete
                      className="text-red-500 hover:text-red-700"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteCart(cart._id);
                      }}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  className="border px-4 py-2 text-center"
                  colSpan="4"
                >
                  No saved carts found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {selectedCart && (
        <Modal open={popupOpen} onClose={() => setPopupOpen(false)}>
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="relative w-full max-w-2xl bg-white rounded-md shadow-lg p-4 sm:p-6 m-2">
              <RxCross1
                size={24}
                className="absolute top-4 right-4 cursor-pointer text-gray-600"
                onClick={() => setPopupOpen(false)}
              />
              <h2 className="text-xl font-semibold text-center mb-4">
                Bundle Name: {selectedCart.bundleName}
              </h2>

              {/* Scrollable container for the popup table */}
              <div className="overflow-x-auto overflow-y-auto max-h-64 sm:max-h-80 mb-4">
                <Table className="w-full table-auto text-xs sm:text-sm">
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="px-2 py-1">S. No</th>
                      <th className="px-2 py-1">Item</th>
                      <th className="px-2 py-1">Quantity</th>
                      <th className="px-2 py-1">Price (WITH GST)</th>
                      <th className="px-2 py-1">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedCart.items.map((item, index) => {
                      const product = productDetails[item.productId];
                      if (!product) return null;

                      return (
                        <tr key={item._id} className="hover:bg-gray-100">
                          <td className="border px-2 py-1 text-center">
                            {index + 1}
                          </td>
                          <td className="border px-2 py-1">
                            <div className="flex flex-col md:flex-row items-center md:items-start">
                              <img
                                src={product.images[0]?.url || "/placeholder.png"}
                                alt={product.name || "Item"}
                                className="w-6 h-6 md:w-8 md:h-8 mr-0 md:mr-2 mb-1 md:mb-0 object-cover rounded flex-shrink-0"
                              />
                              <span className="text-xs md:text-sm whitespace-normal break-words text-center md:text-left">
              {product.name}
              {item.variantKey ? (
                <span className="text-gray-500 text-xs ml-1">
                  ({item.variantKey})
                </span>
              ) : null}
            </span>
          </div>
                          </td>
                          <td className="border px-2 py-1 text-center">
                            <input
                              type="number"
                              value={quantities[item.productId] || 1}
                              onChange={(e) =>
                                handleQuantityChange(
                                  item.productId,
                                  parseInt(e.target.value)
                                )
                              }
                              min="1"
                              className="border rounded-md p-1 w-16 text-center text-xs"
                            />
                          </td>
                          <td className="border px-2 py-1 text-center">
                            ₹{" "}
                            {totalPrices[item.productId]
                              ? totalPrices[item.productId].toFixed(2)
                              : "0.00"}
                          </td>
                          <td className="border px-2 py-1 text-center">
                            <AiOutlineDelete
                              className="text-red-500 hover:text-red-700 cursor-pointer"
                              onClick={() => handleDeleteItem(item.productId)}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              <Button
                onClick={handleProceedToOrder}
                variant="contained"
                color="primary"
                fullWidth
                className="mt-4"
              >
                Proceed to Order
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </div>
     );
    };
  
export default ProfileContent;
